import React, { useState, useEffect } from 'react';
import api from '../../api';

const DynamicContentSections = () => {
    const [sections, setSections] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchSections = async () => {
            try {
                const response = await api.get(`${process.env.REACT_APP_API_URL}/api/content-sections`);
                setSections(response.data.data);
                setLoading(false);
            } catch (err) {
                setError(err.message);
                setLoading(false);
                setSections(false);
            }
        };

        fetchSections();
    }, []);

    if (loading || error || sections.length === 0) return <></>;

    return (
        <>
            {sections.map((section) => (
                <section key={section.id} className="living-on-campus-area">
                    <div className="container">
                        {/* Mobile Layout - Always heading first, then image, then content */}
                        <div className="mobile-content-layout d-block d-md-none">
                            {section.title && (
                                <div className="sec-title about-h3 text-center">
                                    <h2>{section.title}</h2>
                                </div>
                            )}
                            
                            {section.image_url && (
                                <div className="living-on-campus-img-box mb-4">
                                    <div className="inner">
                                        <img 
                                            src={`${process.env.REACT_APP_API_URL}/public/${section.image_url}`} 
                                            alt={section.title} 
                                            className="content-image img-fluid"
                                        />
                                    </div>
                                </div>
                            )}
                            
                            <div className="living-on-campus-content-box">
                                <div className="text">
                                    {section.content.map((paragraph, index) => (
                                        <p key={index} dangerouslySetInnerHTML={{ __html: paragraph }} />
                                    ))}
                                </div>
                            </div>
                        </div>

                        {/* Desktop Layout - Original structure */}
                        <div className="desktop-content-layout d-none d-md-block">
                            <div className="row content-row">
                                {section.layout_type === 'image_left' && (
                                    <>
                                        <div className="col-xl-6">
                                            {section.image_url && (
                                                <div className="living-on-campus-img-box">
                                                    <div className="inner">
                                                        <img 
                                                            src={`${process.env.REACT_APP_API_URL}/public/${section.image_url}`} 
                                                            alt={section.title} 
                                                            className="content-image"
                                                        />
                                                    </div>
                                                </div>
                                            )}
                                        </div>
                                        <div className="col-xl-6">
                                            <div className="living-on-campus-content-box">
                                                {section.title && (
                                                    <div className="sec-title about-h3">
                                                        <h2>{section.title}</h2>
                                                    </div>
                                                )}
                                                <div className="text">
                                                    {section.content.map((paragraph, index) => (
                                                        <p key={index} dangerouslySetInnerHTML={{ __html: paragraph }} />
                                                    ))}
                                                </div>
                                            </div>
                                        </div>
                                    </>
                                )}

                                {section.layout_type === 'image_right' && (
                                    <>
                                        <div className="col-xl-6">
                                            <div className="living-on-campus-content-box">
                                                {section.title && (
                                                    <div className="sec-title about-h3">
                                                        <h2>{section.title}</h2>
                                                    </div>
                                                )}
                                                <div className="text">
                                                    {section.content.map((paragraph, index) => (
                                                        <p key={index} dangerouslySetInnerHTML={{ __html: paragraph }} />
                                                    ))}
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-xl-6">
                                            {section.image_url && (
                                                <div className="living-on-campus-img-box">
                                                    <div className="inner">
                                                        <img 
                                                            src={`${process.env.REACT_APP_API_URL}/public/${section.image_url}`} 
                                                            alt={section.title} 
                                                            className="content-image"
                                                        />
                                                    </div>
                                                </div>
                                            )}
                                        </div>
                                    </>
                                )}

                                {section.layout_type === 'full_width' && (
                                    <div className="col-12">
                                        {section.title && (
                                            <div className="sec-title">
                                                <h2 className="text-center">{section.title}</h2>
                                            </div>
                                        )}
                                        {section.image_url && (
                                            <div className="text-center mb-4">
                                                <img  
                                                    src={`${process.env.REACT_APP_API_URL}/public/${section.image_url}`} 
                                                    alt={section.title} 
                                                    className="img-fluid" 
                                                />
                                            </div>
                                        )}
                                        <div className="content">
                                            {section.content.map((paragraph, index) => (
                                                <p key={index}>{paragraph}</p>
                                            ))}
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </section>
            ))}
        </>
    );
};

export default DynamicContentSections;